/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDashboardData } from '../redux/slice/dashboardSlice';
import { fetchUserData } from '../redux/slice/userSlice';
import {
  AppCurrentVisits,
  AppWebsiteVisits,
  AppWidgetSummary,
} from '../sections/@dashboard/app';
import Pinchecker from '../pages/KRAIntegrations/Pinchecker';
import Iconify from '../components/iconify/Iconify';
import { Button, Stack } from '@mui/material';
// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const theme = useTheme();
  const [openPinchecker, setOpenPinchecker] = useState(false);
  const allData = useSelector((state) => state?.dashboardDetails?.data)
  const userData = useSelector((state) => state?.userDetails?.data)
  const dispatch = useDispatch();
  const [userAction, setUserAction] = useState(null);

  const handleOpenPinchecker = () => setOpenPinchecker(true);
  const handleClosePinchecker = () => setOpenPinchecker(false);

  useEffect(() => {
    if (userData?.length === 0) {
      dispatch(fetchUserData())
    }
    dispatch(fetchDashboardData())
    setUserAction(userAction)
  }, [userAction])

  return (
    <>
      <Pinchecker open={openPinchecker} handleClose={handleClosePinchecker} setUserAction={setUserAction} />
      <Helmet>
        {/* <title> Dashboard | Minimal UI </title> */}
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Dashboard
        </Typography>
        <Stack direction="row" alignItems="center" justifyContent={"flex-end"} spacing={2}>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenPinchecker}>
            Check KRA PIN
          </Button>
          </Stack>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={2}>
            <AppWidgetSummary title="Leads" total={allData?.totalLead} icon={'ic:baseline-leaderboard'} />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <AppWidgetSummary title="Contacts" total={allData?.totalContact} color="info" icon={'fluent:book-contacts-24-filled'} />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <AppWidgetSummary title="Policies" total={allData?.totalProject} color="warning" icon={'ic:baseline-project'} />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <AppWidgetSummary title="Tasks" total={allData?.totalTask} color="primary" icon={'mdi:events'} />
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <AppWidgetSummary title="Expired Tasks" total={allData?.totalExpired} color="error" icon={'mdi:events'} />
          </Grid>
          <Grid item xs={12} md={6} lg={8}>
            <AppWebsiteVisits
              title="Monthly feeEarneds"
              subheader="Chart"
              chartLabels={allData?.feeEarnedkeys || [] }
              chartData={[
                // {
                //   name: 'Team A',
                //   type: 'line',
                //   fill: 'solid',
                //   data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
                // },
                // {
                //   name: 'Team B',
                //   type: 'area',
                //   fill: 'gradient',
                //   data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
                // },
                {
                  name: 'feeEarned',
                  type: 'column',
                  fill: 'solid',
                  data: allData?.feeEarnedvalues || [],
                },
              ]}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits
              title="Acquired Policies"
              chartData={allData?.projects || []}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.info.main,
                theme.palette.warning.main,
                theme.palette.error.main,
              ]}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
